import {
  CHARGES_LIST_REQUEST,
  CHARGES_LIST_SUCCESS,
  CHARGES_LIST_ERROR,
  CHARGES_LIST_RESET,
} from "./ActionType";
import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";

export const listCharges = (payload) => {
  const { shopId, storeType, first = 25, afterCursor } = payload;
  return (dispatch) => {
    dispatch({ type: CHARGES_LIST_REQUEST });
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.chargesList(
      shopId,
      storeType,
      first,
      afterCursor
    )}`;

    fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(`HTTP ${res.status}: ${text.slice(0, 200) || res.statusText}`);
        }
        return res.json();
      })
      .then((data) => dispatch({ type: CHARGES_LIST_SUCCESS, payload: data }))
      .catch((err) =>
        dispatch({ type: CHARGES_LIST_ERROR, payload: err?.message || "Network error" })
      );
  };
};

export const resetChargesList = () => ({ type: CHARGES_LIST_RESET });
